/**
 * Multi-value text the user typed into one field: one item per line, or a
 * comma-separated list. Interpreting free text a person entered is boundary
 * work, and five editors had each done it slightly differently — some kept
 * blank lines, some kept surrounding spaces.
 */

/** One item per line, trimmed, with blank lines dropped. */
export function linesEntered(value: string): string[] {
  return value
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
}

/** Comma-separated items, trimmed, with empty entries dropped. */
export function commaSeparatedEntered(value: string): string[] {
  return value
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}
